// extracted by mini-css-extract-plugin
export default {"root":"StripeSetup_root__CSk4M","actions":"StripeSetup_actions__5UbrB"};